import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import Form, { DateInput, FormBody, SelectInput, TextInput } from '../Form';
import FormMultiSelectInput from '../FormMultiSelectInput';
import booleanPointInPolygon from '@turf/boolean-point-in-polygon';
import { point } from '@turf/helpers';
import * as storage from '../../libs/localStorage';
import moment from 'moment';
import { utc } from '../../libs/date';

@inject('uiStore')
@observer
class MapFilterGroup extends React.Component {

  user_id = storage.token.getDecoded().id;

  state = {
    multiTagOptions: [],
  }

  @observable selectedStatus = '';
  @observable statusDays = 1;
  @observable customDays = 1;
  @observable selectedDivision = 'all';
  @observable selectedBoundary = null;
  @observable selectedBoundaryFeature = null;
  @observable selectedToDateFilter = ''

  componentWillMount() {
    this.populateOptions();
  }

  populateOptions = () => {
    const { tagsProps, stationProps, statusProps } = this.props;
    if (!tagsProps.tags || !tagsProps.tags.length || !stationProps.stations.length) {
      setTimeout(() => {
        this.populateOptions();
      }, 100);
    } else {
      let previousTags = storage.tags.get();
      // let multiTagOptions = tagsProps.tags.reduce((acc, item) => {
      //   if(!item.stations || !item.stations.length) return acc;
      //   const previouslySelected = previousTags.find(i => i === item.name);
      //   acc.push({
      //     id: item.id,
      //     name: item.name,
      //     label: item.name,
      //     value: !!previouslySelected
      //   })
      //   return acc;
      // }, []);
           let multiTagOptions = stationProps.stations.reduce((acc, station) => {
        if (!station.tags || station.tags.length === 0) return acc

        station.tags.forEach((tag) => {
          if (!acc.find(t => t.id === tag.id)) {
            const previouslySelected = previousTags.find(i => i === tag.name);
            acc.push({
              id: tag.id,
              name: tag.name,
              label: tag.name,
              value: !!previouslySelected
            })
          }
        })
        return acc
      },[])
      const isGwhsTagSelected = multiTagOptions.some(tag => tag.id === 382 && tag.value);

      this.setState({ multiTagOptions }, () => {
         if (isGwhsTagSelected) {
          this.statusDays = 2;
        statusProps && statusProps.onChangeStatusDays({ target: { value: 2 } });
         }

        this.filterStations(stationProps);
      });
    }
  }

  @action onChangeDivision = (division, stationProps) => {
    this.selectedDivision = division;
    this.selectedBoundary = null;
    this.selectedBoundaryFeature = null;
    this.filterStations(stationProps);
    // setFilteredStations(null, stations);
  }

  @action onChangeBoundary = (division, boundary, stationProps) => {
    this.selectedBoundary = boundary;
    this.selectedBoundaryFeature = division.geoJson.features.find(d => d.properties[division.key] === boundary);
    this.filterStations(stationProps);

    // setFilteredStations(
    //   selectedBoundaryFeature,
    //   !boundary ? stations : stations.filter(station => booleanPointInPolygon(point([station.longitude, station.latitude]), selectedBoundaryFeature.geometry))
    // )
  }

  @action onTagSelect = (item, stationProps) => {
    // if (Array.isArray(item)) this.setState({ multiTagOptions: item }, () => this.setFilteredTags(stationProps));
    // else {
    //   item.value = !item.value
    //   this.setFilteredTags(stationProps);
    // };
  //   // onChangeSearchTags(multiTagOptions.filter(item => !!item.value).map(item => item.name))

  const { multiTagOptions } = this.state;
  const { statusProps } = this.props;

  let updatedOptions = Array.isArray(item)
    ? item
    : multiTagOptions.map(tag => tag.id === item.id ? { ...tag, value: !tag.value } : tag);

  this.setState({ multiTagOptions: updatedOptions }, () => {
    this.setFilteredTags(stationProps);
    const isGwhsTagSelected = updatedOptions.some(tag => tag.id === 382 && tag.value);

    if (isGwhsTagSelected) {
      this.statusDays = 2;
        statusProps && statusProps.onChangeStatusDays({ target: { value: 2 } });
        this.filterStations(stationProps); 
    }
  });
  }

  setFilteredTags = (stationProps) => {
    let selectedTags = this.state.multiTagOptions.filter(item => !!item.value).map(item => item.name);
    storage.tags.set(selectedTags)
    this.filterStations(stationProps);
  }

  filterStations = ({ stations, setFilteredStations, setSelectedBoundary, noLatLng }) => {
    if (!!setSelectedBoundary) setSelectedBoundary(this.selectedBoundaryFeature)
    const checkStatusDays = this.statusDays === 'custom' ? this.customDays : this.statusDays;
    const status_time = storage.preference.get().status_time || 'timestamp';
    let selectedTags = this.state.multiTagOptions.filter(item => !!item.value).map(item => item.name);
    let filteredStations = stations
      .filter(station => {
        if (!noLatLng &&  (!station.longitude || !station.latitude)) return false;
        let color = station.color === 'YELLOW' ? 'YELLOW' : moment(utc(station[`max_station_${status_time}`])).utc().isBetween(moment.utc().subtract(checkStatusDays, 'days'), moment.utc()) ? 'GREEN' : 'RED';
        station.color = color;
        if (this.selectedStatus !== '' && color !== this.selectedStatus) return false;
        if (!!this.selectedToDateFilter && !moment(station.max_station_time).isSameOrBefore(this.selectedToDateFilter, 'day')) return false;
        if (selectedTags.length === 0) return false;
        if (!station.tags || !station.tags.length) return false;
        if (!station.tags.find(tag => selectedTags.includes(tag.name))) return false;
        if (!!this.selectedBoundaryFeature) return booleanPointInPolygon(point([station.longitude, station.latitude]), this.selectedBoundaryFeature.geometry)
        return true;
      });

    setFilteredStations(filteredStations);
  }

  _renderStatusFilter = (statusProps, stationProps) => {
    const { uiStore } = this.props;

    return (
      <div className={uiStore.mobileView ? '' : 'flex flex-row'} style={uiStore.mobileView ? {} : { marginBottom: '-10px' }}>
        <SelectInput
          label={'Station Status'}
          fields={{ label: 'status', value: 'color' }}
          options={[
            { status: 'No Communication', color: 'RED' },
            { status: 'Normal', color: 'GREEN' },
            { status: 'QC Error', color: 'YELLOW' },
          ]}
          onChange={e => {
            this.selectedStatus = e.target.value;
            this.filterStations(stationProps);
          }}
          value={this.selectedStatus}
        />
        {!!statusProps &&
          <SelectInput id='dataDays' label={uiStore.mobileView ? 'Status Since' : ''} value={statusProps.statusDays} small={!uiStore.mobileView}
            onChange={(e) => {
              this.statusDays = e.target.value;
              statusProps.onChangeStatusDays(e);
              this.filterStations(stationProps);
            }}
            fields={{ label: 'label', value: 'value' }}
            options={[
              { label: '1 Day', value: 1 },
              { label: '2 Days', value: 2 },
              { label: '3 Days', value: 3 },
              { label: '7 Days', value: 7 },
              { label: 'Custom Days', value: 'custom' },
            ]} />}

        {this.statusDays === 'custom' && <TextInput type="number" min="1" label="" placeholder="Custom Day" small={!uiStore.mobileView}
          value={this.customDays}
          onChange={(e) => {
            if (e.target.value < 1) return;
            this.customDays = e.target.value;
            statusProps.onChangeStatusDays(e);
            this.filterStations(stationProps);
          }}
        />}
      </div>
    )
  }

  _renderTagsFilter = ({ isLoading }, stationProps) => {
    return (
      <FormMultiSelectInput
        id='tag-multi-select'
        label='Tags'
        options={this.state.multiTagOptions}
        optionClicked={item => this.onTagSelect(item, stationProps)}
        optionsChangeAll={newOptions => this.onTagSelect(newOptions, stationProps)}
        isLoading={isLoading}
      />
    );
  }

  _renderDivisionFilter = ({ options }, stationProps) => {
    let selectedDivision = options.find(item => item.value === this.selectedDivision);
    return (
      <Form>
        <FormBody>
          <SelectInput
            label={'Administrative Division'}
            fields={{ label: 'label', value: 'value' }}
            options={options}
            onChange={e => this.onChangeDivision(e.target.value, stationProps)}
            value={this.selectedDivision}
          />
          {this.selectedDivision !== 'all' && this.selectedDivision !== '' &&
            <SelectInput
              label={selectedDivision.label}
              fields={{ label: selectedDivision.key, value: selectedDivision.key }}
              options={!!selectedDivision.geoJson.features ? selectedDivision.geoJson.features.map(item => ({ [selectedDivision.key]: item.properties[selectedDivision.key] })) : []}
              onChange={e => this.onChangeBoundary(selectedDivision, e.target.value, stationProps)}
              value={this.selectedBoundary}
            />
          }
        </FormBody>
      </Form>
    );
  }

  _renderDateFilter = (stationProps) => {
    return (
      <Form>
        <FormBody>
          <DateInput
            label={'Date'}
            type="date"
            value={this.selectedToDateFilter}
            onChange={e => {
              this.selectedToDateFilter = e.target.value;
              this.filterStations(stationProps);
            }}
          />
        </FormBody>
      </Form>
    );
  }

  render() {
    const { statusProps, tagsProps, divisionProps, stationProps, children } = this.props;
    return (
      <div>
        <div className='map-filter-group'>
          <Form>
            <FormBody>
              {this._renderStatusFilter(statusProps, stationProps)}
              {!!tagsProps && this._renderTagsFilter(tagsProps, stationProps)}
            </FormBody>
          </Form>
          <div>
            {!!divisionProps && this._renderDivisionFilter(divisionProps, stationProps)}
            {this._renderDateFilter(stationProps)}
          </div>
        </div>
        {children}
      </div>
    );
  }
}

export default MapFilterGroup;


// WEBPACK FOOTER //
// ./src/components/Map/MapFilterGroup.js